<template>
    <span v-if="ShowPrice">{{Name}} {{SmartPrice}}</span>
</template>

<script>
export default {
    name: 'Price',
    computed: {
        ShowPrice() {
            return this.$root.showPricing;
        },
        SmartPrice() {
            if (this.Value <= 0) return 'n/a';

            return this.$currencySymbol() + this.Value;
        }
    },
    props: {
        Name: { default:'', type:String },
        Value: Number
    }    
}
</script>
